export default "__VITE_ASSET__96bd8dcc__"